module.exports = __webpack_public_path__ + "img/image04_sp.ef3b4efc.jpg";